import { createFileRoute, Navigate } from '@tanstack/react-router';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { isMenuGroup } from '@/admin/navigation/LeftMenu';
import { useVisibleNavigation } from '@/admin/navigation/useVisibleNavigation';
import { useCurrentUser } from '~/hooks/useCurrentUser';

export const Route = createFileRoute('/admin/')({
  // Every tier lands here; the redirect picks what that tier can open.
  staticData: { minTier: 'FRONT_END_SUPPORT' },
  component: Index,
});

function Index(): ReactElement {
  const { t } = useTranslation();
  const { me } = useCurrentUser();
  const visible = useVisibleNavigation(me);
  const first = visible.flatMap((e) => (isMenuGroup(e) ? e.children : [e]))[0];

  if (first) return <Navigate to={first.to} replace />;
  return <p>{t('admin.home.noScreens')}</p>;
}
